import { Map, VectorSourceSpecification, VectorTileSource } from 'maplibre-gl';
import { PMTiles, Protocol } from 'pmtiles';
export class MapContentVectorSource {

  constructor(
    public sourceId: string,
    private url: string,
    private pmTiles?: PMTiles,
  ) {}

  updateMap(map: Map, protocol: Protocol) {
    const mapSource = map.getSource(this.sourceId);
    if (mapSource == null) {
      if (protocol && this.pmTiles) {
        protocol.add(this.pmTiles);
      }
      map.addSource(this.sourceId, {
        type: 'vector',
        url: this.url,
      } as VectorSourceSpecification);
    } else {
      const mapSourceCast = mapSource as VectorTileSource;
      mapSourceCast.setUrl(this.url);
    }
  }
}
